exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.zoom-container {\n\tposition: relative;\n\toverflow: hidden;\n}\n.zoom-container .normal-image {\n\twidth: 100%;\n}\n.zoom-container .zoomed-image {\n\tpointer-events: none;\n\tposition: absolute;\n\topacity: 0;\n\ttransform-origin: top left;\n}\n\n", ""]);

// exports
